class WarrantyFormHandler {
    constructor() {
        this.warrantyApiUrl = 'https://portal.babybrezza.com/api/warranty/activate';
        this.listrakApiUrl = 'https://optin.babybrezza.com/api/subscribe/listrak';
        this.klaviyoApiUrl = 'https://optin.babybrezza.com/api/subscribe/klaviyo';
        this.reviewApiUrl = 'https://portal.babybrezza.com/api/review';

        this.registerWrapper = document.querySelector(".warranty-main-form-wrapper");
        this.reviewWrapper = document.querySelector(".submit-review");
        this.successWrapper = document.querySelector(".successful-review-submission-container");
        this.noThanksWrapper = document.querySelector(".no-thanks-review-exit");

        this.registerForm = document.querySelector(".register-product-form");
        this.reviewForm = document.querySelector(".submit-review-form");
        this.noThanksBtn = document.querySelector("#noThanks");

        this.categoryCards = document.querySelectorAll(".category-selection-card");
        this.productCards = document.querySelectorAll(".product-selection-card");
        this.productSection = document.getElementById("productCardSection");

        this.website = document.getElementById("website");
        this.userInfo = document.getElementById("userInfo");

        this.productInputName = document.getElementById("selectedProductName");
        this.productInputID = document.getElementById("selectedProductID");
        this.productInputURL = document.getElementById("selectedProductURL");

        this.acceptanceCheckbox = document.getElementById("acceptance");

        this.init();

        const translationEl = document.getElementById("translations-warranty-form");

        this.translations = {
            captchaError: translationEl?.dataset.captchaError,
            invalidEmail: translationEl?.dataset.invalidEmail,
            productError: translationEl?.dataset.productError,
            registrationFailed: translationEl?.dataset.registrationFailed,
            registrationSuccess: translationEl?.dataset.registrationSuccess,
            serverError: translationEl?.dataset.serverError,
            reviewFailed: translationEl?.dataset.reviewFailed,
            reviewSuccess: translationEl?.dataset.reviewSuccess
        };
    }

    init() {
        this.bindCategorySelection();
        this.bindProductSelection();
        this.registerForm?.addEventListener("submit", e => this.handleRegister(e));
        this.reviewForm?.addEventListener("submit", e => this.handleReview(e));
        this.noThanksBtn?.addEventListener("click", e => this.handleNoThanks(e));
    }

    /* ===============================
       STRONG EMAIL VALIDATION
    =============================== */
    isValidEmail(email) {
        if (!email || email.length > 254) return false;

        // ASCII only (emoji, unicode yok)
        if (!/^[\x00-\x7F]+$/.test(email)) return false;

        const [local, domain] = email.split("@");
        if (!local || !domain) return false;

        // Local-part rules
        if (
            local.length < 2 ||
            local.length > 64 ||
            local.startsWith(".") ||
            local.endsWith(".") ||
            local.includes("..")
        ) return false;

        // Domain rules
        if (
            domain.length < 4 ||
            domain.includes("..") ||
            !domain.includes(".")
        ) return false;

        const tld = domain.split(".").pop();
        if (!tld || tld.length < 2 || tld.length > 24) return false;

        // RFC-safe regex (strict)
        const strictRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,24})+$/;
        return strictRegex.test(email);
    }

    bindCategorySelection() {
        this.categoryCards.forEach(card => {
            card.addEventListener("click", () => {
                this.categoryCards.forEach(c => c.classList.remove("is-selected"));
                card.classList.add("is-selected");

                const category = card.dataset.categoryName;
                this.productSection.style.opacity = "1";
                this.productSection.style.pointerEvents = "auto";

                this.productCards.forEach(p => {
                    p.style.display = p.dataset.parentCategory === category ? "flex" : "none";
                    p.classList.remove("is-selected");
                });

                this.productInputID.value = "";
                this.productInputName.value = "";
                this.productInputURL.value = "";
            });
        });
    }

    bindProductSelection() {
        this.productCards.forEach(card => {
            card.addEventListener("click", () => {
                this.productCards.forEach(p => p.classList.remove("is-selected"));
                card.classList.add("is-selected");

                this.productInputID.value = card.dataset.productId;
                this.productInputName.value = card.dataset.productName;
                this.productInputURL.value = card.dataset.productUrl;
            });
        });
    }

    showToast(message,type,link = "",link_text= "") {
        // Create a completely new toast for this message
        if(document.getElementById("toast-item")) document.getElementById("toast-item").remove()
        const newToast = document.createElement('div');
        newToast.className = 'dynamic-toast';
        // Add the toast to the warranty form container if it exists, otherwise to body
        document.body.appendChild(newToast);
        let bgColor = "#fff"
        let colorItem = "#000"
        let icon = `<svg class="icon icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path fill="${colorItem}" stroke="#fff" d="M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z"/>
                        </svg>`
        if(type === "error"){
            bgColor = "#fff"
            colorItem = "#a60f00"
            icon = '<svg class="icon icon-tick" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/></svg>'
        }
        newToast.id = "toast-item";
        let link_section = ""
        if(link !== "" && link_text !== "" ){
            link_section = `<div><a href="${link}" class="reversed-link btn btn--underline text-sm">${link_text}</a></div>`
        }
        // Set content
        newToast.innerHTML = `
            ${icon}
            <div class="toast-text font-bold ">${message} <br/> ${link_section}</div>
        `;
        // Fix styling issues that might be causing visibility problems
        newToast.style.cssText = `
            position: fixed;
            top: 100px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 99999;
            display: flex;
            opacity: 0;
            visibility: visible;
            transition: transform 0.5s ease, opacity 0.5s ease;
            border: 1px solid #f2f2f2;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            background-color: #fff;
            max-width: 90%;
            width: auto;
        `;

        // Style the toast text
        const textElement = newToast.querySelector('.toast-text');
        if (textElement) {
            textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 16px;
                font-weight: 500;
            `;
            if(window.innerWidth < 430){
                textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 14px;
                font-weight: 500;
            `;
            }
        }

        // Style the icon
        const iconElement = newToast.querySelector('.icon');
        if (iconElement) {
            iconElement.style.cssText = `
                width: 55px;
                ${link_section === "" ? "height: 100%;" : "height:90px;"}
                padding: 10px;
                background-color: #fff;
                ${link_section === "" ? "box-shadow: 0px 4px 10px rgb(19 152 128 / 30%);" : ""}
                border-radius: 4px 0 0 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
        }

        // Force the toast to be visible
        setTimeout(() => {
            newToast.style.opacity = '1';
            newToast.style.transform = 'translate(-50%, 75px)';
        }, 10);

        // Hide toast after 3 seconds
        setTimeout(() => {
            newToast.style.opacity = '0';
            setTimeout(() => {
                newToast.remove();
            }, 500);
        }, 2500);
    }

    async handleRegister(e) {
        e.preventDefault();

        const captcha = document.querySelector('[name="cf-turnstile-response"]')?.value;
        if (!captcha) {
            this.showToast(this.translations.captchaError, "error");
            return;
        }

        const formData = new FormData(e.target);
        const email = formData.get("email")?.trim();
        const firstName = formData.get("first_name");
        const lastName = formData.get("last_name");

        if (!this.isValidEmail(email)) {
            this.showToast(this.translations.invalidEmail, "error");
            return;
        }

        if (!this.productInputID.value) {
            this.showToast(this.translations.productError, "error");
            return;
        }

        const payload = {
            email,
            first: firstName,
            last: lastName,
            product: this.productInputName.value,
            productId: this.productInputID.value,
            website: this.website.value,
            is_vip: Boolean(this.userInfo.value),
            opt_in: false,
            captchaToken: captcha
        };

        try {
            const res = await fetch(this.warrantyApiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (!res.ok) {
                this.showToast(result.message || this.translations.registrationFailed, "error");
                return;
            }

            if (this.acceptanceCheckbox?.checked) {
                const finalLink = this.website.value === 'US'
                    ? this.listrakApiUrl
                    : this.klaviyoApiUrl;

                fetch(finalLink, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        email,
                        firstName,
                        lastName,
                        store: this.website.value,
                        selectedProduct: this.productInputName.value
                    })
                }).catch(() => {});
            }

            this.showToast(this.translations.registrationSuccess, "success");
            this.registerWrapper.style.display = "none";
            this.reviewWrapper.style.display = "block";

        } catch {
            this.showToast(this.translations.serverError, "error");
        }
    }

    async handleReview(e) {
        e.preventDefault();

        const reviewFormData = new FormData(e.target);
        const params = new URLSearchParams({
            website: this.website.value,
            sku: this.productInputID.value,
            product_title: this.productInputName.value,
            product_url: this.productInputURL.value,
            display_name: `${this.registerForm.querySelector('[name="first_name"]').value} ${this.registerForm.querySelector('[name="last_name"]').value}`,
            email: this.registerForm.querySelector('[name="email"]').value,
            review_content: reviewFormData.get("detail"),
            review_title: reviewFormData.get("title"),
            review_score: reviewFormData.get("rating")
        });

        const res = await fetch(this.reviewApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        });

        if (!res.ok) {
            this.showToast(this.translations.reviewFailed, "error");
            return;
        }

        this.showToast(this.translations.reviewSuccess, "success");
        this.reviewWrapper.style.display = "none";
        this.successWrapper.style.display = "flex";
    }

    handleNoThanks(e) {
        e.preventDefault();
        this.reviewWrapper.style.display = "none";
        this.noThanksWrapper.style.display = "flex";
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new WarrantyFormHandler();
});
